import React, { Component } from "react";
import Header from '../../components/home/header/header'
class Layout4 extends Component {
    render() {
        const { customBg } = this.props;
        return (
            <>
                <Header />
                <div className={customBg ? "bg-white" : ""}>
                    <div className="main">
                        {this.props.children}
                    </div>
                </div>
            </>
        );
    }
}

export default Layout4;
